export default __webpack_public_path__ + "static/media/inspection_large.26e51b24.png";